import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import {
  ElearningDetailHero,
  ElearningDetailCourse,
} from "@modules/elearning/details";

const ElearningDetails = () => {
  return (
    <LayoutMain footer_with_evaluation title="eLearning">
      <ElearningDetailHero />
      <ElearningDetailCourse />
    </LayoutMain>
  );
};

export default ElearningDetails;
